import { EntitiesVisualizer } from '../entities-visualizer';
import { VisualizerStateStyle } from '../models/visualizer-state';

export const FootprintHeatmapVisualizerType = 'FootprintHeatmapVisualizer';

export class FootprintHeatmapVisualizer extends EntitiesVisualizer {
	static type = FootprintHeatmapVisualizerType;

	constructor(style: Partial<VisualizerStateStyle>) {
		super(FootprintHeatmapVisualizerType, style, {
			opacity: 0.5,
			initial: {
				fill: {
					color: 'rgba(255, 0, 0, 0.05)'
				},
				stroke: {
					color: 'rgba(0, 0, 0, 0.02)'
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/open-layer-visualizers/overlays/heatmap-visualizer.ts